export default function Button({ type = "button", onClick, text, disabled = false, variant = "primary", block = true, style = "", children }) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={!!disabled}
            className={`btn-ms btn-ms-${variant} ${block ? "btn-ms-block" : ""} ${style}`}
        >
            {disabled === "loading"
                ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                : (children || text)}
        </button>
    )
}
